export default "/images/corner-up-left.svg?f219878b7b8999c3c273cefe5452f680";